import { filterParamMapping } from '../common/mappings';
import { trimAndAddAsterisk } from '../../utility/QueryUtility';

export const lossRunsParamsSerializer = [
  { path: 'page' },
  { path: 'size' },
  {
    paramKey: 'sort',
    transform: ({ orderBy, order }: any) => {
      if (orderBy && order) {
        switch (orderBy) {
          case 'modified':
          case 'created':
          case 'effectiveDate':
          case 'endDate':
            return `${orderBy},${order}`;
          default:
            return `${orderBy}.keyword,${order}`;
        }
      }
      return null;
    },
  },
  {
    path: 'search',
    transform: ({ search = '' }) =>
      !search ? search : trimAndAddAsterisk(search),
  },
  filterParamMapping,
  { path: 'searchAfter' },
  { path: 'pageRequested' },
  { path: 'accountId' },
];
